import { IconStorage } from "@app/shared/icons/interfaces";

export const x: IconStorage = {
  svgCode: () => ([
    "M17 7L7 17M7 7L17 17",
  ]),
};

export const xCircle: IconStorage = {
  svgCode: () => ([
    "M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
  ]),
}

export const xClose: IconStorage = {
  svgCode: () => ([
    "M18 6L6 18M6 6L18 18",
  ]),
}
